// @flow
import React from 'react';
import {Col, Row} from 'reactstrap';

type PageTitleProps = {
    title: string,
    onBack?: PropTypes.func
};

/**
 * PageTitle
 */
const PageTitle = (props: PageTitleProps) => {
    return (
        <Row className='navbar-custom'>
            <Col>
                <div className="page-title-box">
                    {props.onBack ?
                        <i className="page-back-arrow mdi mdi-arrow-left" onClick={props.onBack}></i> : null}
                    <h4 className="page-title">{props.title}</h4>
                </div>
            </Col>
        </Row>
    );
};

export default PageTitle;
